import React, { ReactNode, useState } from "react";
import LayoutContext from "./LayoutContext";

const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [pageTitle, setPageTitle] = useState<string>("");
  const [pageExtra, setPageExtra] = useState<ReactNode | null>(null);

  return (
    <LayoutContext.Provider
      value={{
        pageTitle,
        setPageTitle,
        pageExtra,
        setPageExtra,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
